import classNames from 'classnames';
import BaseIcon from '../../../../baseComponents/gui/icon/Icon';

export default function Icon({ icon, isNew, newType }) {
  return (
    icon && (
      <div className={'button__icon button_transparent custom-button__icon'}>
        <BaseIcon name={icon} />
        {isNew && <span className={classNames('button__circle', { [`button__circle_${newType}`]: newType })} />}
      </div>
    )
  );
}
